import moment from 'moment';
import { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import AuthContext from '../../../contexts/AuthContext';
import WalletContext from '../../../contexts/WalletContext';
import useAPI from '../../../hooks/useAPI';
import { formatCurrency } from '../../../utility/number.utils';
import WalletInfoCard from '../../common/walletInfoCard';
import RequestCashOutModal from '../../dialogs/request-cash-out-dialog';
import Skeletone from '../../ui/Skeletone';
import styles from './style.module.scss';
import TokenListContext from '../../../contexts/TokenListContext';

const CashoutWalletInfo = ({
  refetch: cashoutRefetch,
}: {
  refetch?: () => void;
}) => {
  const [cashOutModal, setCashOutModal] = useState(false);
  const { userRole } = useContext(AuthContext);
  const { tokenList } = useContext(TokenListContext);

  const { walletData, isLoading, refetch } = useContext(WalletContext);

  const { refetch: refetchCashOut } = useAPI({
    url: `/token/transaction/history/get/cashout?status=&date=&type=`,
    method: 'GET',
    autoFetch: false,
  });

  const hundleCashOut = () => {
    if (!walletData?.Balance) {
      toast.error(
        'Your token request cannot be processed as no tokens have been created yet. Please contact your administrator to generate the necessary tokens',
      );
    } else {
      setCashOutModal(true);
    }
  };
  return (
    <>
      <RequestCashOutModal
        open={cashOutModal}
        onClose={() => {
          setCashOutModal(false);
          refetch();
          cashoutRefetch?.();
        }}
        refetch={refetchCashOut}
      />
      <div className={styles.wrapper}>
        {isLoading ? (
          <Skeletone variant="dark" />
        ) : (
          <WalletInfoCard
            loading={isLoading}
            amount={`${walletData?.Balance ? formatCurrency(walletData?.Balance, { currency: '', decimals: 0 }) : 0}`}
            title="Wallet Balance"
            buttonText="Request Cash Out"
            lastTransaction={`${walletData?.LastTransaction ? formatCurrency(walletData?.LastTransaction, { currency: '', decimals: 0 }) : 'No Cash Outs Yet'}`}
            lastTransactionText="Last Transaction"
            variant="dark"
            // onButtonClick={() => setCashOutModal(true)}
            onButtonClick={hundleCashOut}
          />
        )}
        {isLoading ? (
          <Skeletone variant="light" />
        ) : (
          <WalletInfoCard
            loading={isLoading}
            amount={`${walletData?.LastCashout ? formatCurrency(walletData?.LastCashout, { currency: '', decimals: 0 }) : 0}`}
            title="Last Cash Out"
            lastTransaction={`${walletData?.LastCashoutDate ? moment(walletData?.LastCashoutDate).format('D MMM YYYY HH:mm:ss') : 'No Cash Outs Yet'}`}
            lastTransactionText="On"
          />
        )}
        {isLoading ? (
          <Skeletone variant="light" />
        ) : (
          <WalletInfoCard
            loading={isLoading}
            amount={`${walletData?.pendingCashout ? formatCurrency(walletData?.pendingCashout, { currency: '', decimals: 0 }) : 0}`}
            title="Pending Cash Out"
            lastTransactionText="Pending"
          />
        )}
      </div>
    </>
  );
};

export default CashoutWalletInfo;
